import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const AdminPage = () => {
  return (
    <AdminLayout currentPage={'Admin'}>
      <Spacing size={'md'} direction={'horizontal'}>
        <p className='flex-grow'>
          Hello administrator! Use the links on the left side of the screen to
          navigate to various administrative screens.
        </p>

        <div className='flex-end'>
          <Button
            behavior={{
              type: 'href',
              href: `/overview`,
            }}
            text={'Go to Overview'}
          />
        </div>
      </Spacing>
    </AdminLayout>
  );
};
